"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { Flex, FlexCenter, NumberDisplay, SpaceBetween, TextBody, TextBodySkeleton, Tooltip } from "@opensea/ui-kit";
import { Info } from "@opensea/ui-kit/icons";
import { BigNumber, bn } from "@opensea/utils";
import { useTranslations } from "use-intl";
import { useSwapCurrencies } from "../../../hooks/useSwapCurrencies";
import { SwapDetailsProviderFeeItemFragment } from "./SwapDetailsProviderFeeItem.fragment";
export const SwapDetailsProviderFeeItem = t0 => {
  const $ = _c(22);
  const {
    swapRoute: swapRouteKey
  } = t0;
  const swapRoute = readFragment(SwapDetailsProviderFeeItemFragment, swapRouteKey);
  const t = useTranslations("wallet.SwapDetailsProviderFeeItem");
  const {
    fromAsset,
    toAsset
  } = useSwapCurrencies({
    swapRoute
  });
  const isBridge = fromAsset && toAsset && fromAsset.chainIdentifier !== toAsset.chainIdentifier;
  if (!swapRoute || swapRoute.__typename !== "SwapRoute") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <SwapDetailsProviderFeeItemSkeleton />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const fromAssetPriceUsd = bn(swapRoute.pricePerFromAsset.usd);
  const providerFeeUsd = BigNumber.sum(...swapRoute.costs.filter(_temp).map(_temp2));
  const providerFeePercentage = fromAssetPriceUsd.isZero() ? bn(0) : providerFeeUsd.div(fromAssetPriceUsd);
  const T0 = SpaceBetween;
  let t1;
  if ($[1] !== t) {
    t1 = t("providerFee");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <TextBody>{t1}</TextBody>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isBridge || $[6] !== t) {
    t3 = isBridge && <Tooltip content={t("providerFeeTooltip")}><Info size={16} /></Tooltip>;
    $[5] = isBridge;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <FlexCenter className="gap-1">{t2}{t3}</FlexCenter>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const T1 = Flex;
  const t5 = "gap-1.5";
  const t6 = !providerFeeUsd.isNaN() && <TextBody className="font-mono" color="text-secondary">(<NumberDisplay display="usd" value={providerFeeUsd} />)</TextBody>;
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      maximumFractionDigits: 2
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== providerFeePercentage) {
    t8 = <TextBody asChild={true}><NumberDisplay custom={t7} display="percent" value={providerFeePercentage} /></TextBody>;
    $[12] = providerFeePercentage;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== T1 || $[15] !== t6 || $[16] !== t8) {
    t9 = <T1 className={t5}>{t6}{t8}</T1>;
    $[14] = T1;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== T0 || $[19] !== t4 || $[20] !== t9) {
    t10 = <T0>{t4}{t9}</T0>;
    $[18] = T0;
    $[19] = t4;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
};
const SwapDetailsProviderFeeItemSkeleton = () => {
  const $ = _c(7);
  const t = useTranslations("wallet.SwapDetailsProviderFeeItem");
  let t0;
  if ($[0] !== t) {
    t0 = t("providerFee");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <TextBody>{t0}</TextBody>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TextBodySkeleton className="w-[100px]" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1) {
    t3 = <SpaceBetween>{t1}{t2}</SpaceBetween>;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
function _temp(c) {
  return c.costType === "PROVIDER";
}
function _temp2(c_0) {
  return c_0.cost.usd;
}